import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'




// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    speed:1000,
    loop:true,//必须
    pagination: {
        el: ".banner .swiper-pagination",
        clickable: true,
    },
});

$(".section1 .product-list .content").eq(0).addClass("active");
$(".section1 .product-nav li").eq(0).addClass("active");
$(".section1 .product-nav li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section1 .product-list .content").eq(index).addClass("active").siblings().removeClass("active");
})

var swiper = new Swiper(".section1 .swiper", {
    navigation: {
        nextEl: ".section1 .swiper .swiper-button-next",
        prevEl: ".section1 .swiper .swiper-button-prev",
    },
});


